// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/cursor.ico", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/cursor2.ico", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/cursor3.ico", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  overflow: hidden;
  /* just change the cursor.ico path to your location */
}

.cursor0 {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), auto;
}

.cursor1 {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), auto;
}

.cursor2 {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_2___}), auto;
}


.App {
  text-align: center;
  background-color: hsl(0, 0%, 22%);
  color: rgb(224, 255, 47);
  overflow: hidden;
}

.title {
  font-style: italic;
  padding: 2%;
  text-align: left;
  align-items: left;
  color: rgb(224, 255, 47);
}

.description {
  font-size: .5em;
}

h2 {
  font-family: 'Baskerville';
  font-style:italic;
  font-weight:normal;
}



code {
  font-family: code,
    monospace;
}


.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  padding-top: 10%;
  background-color: #8ea604;
  min-height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: rgb(0, 0, 0);
  padding: 2%;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.body {
  height: 100%;
  overflow-y: hidden;
}

.column1 {
  float: left;
  width: 68%;
  height: 100%;
  overflow-y: scroll;
  scrollbar-color: rgb(255, 255, 255) #8ea604;
  scrollbar-width:thin;
  height: calc(100vh);

}

 /* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #8ea604;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(255, 255, 255);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
} 

a { 
  color: inherit;
  font-size: 80%;
 } 
.column2 {
  border-left: 2px solid #736161;
  float: right;
  width: 30%;
  background-color: #0d0d0d;
  height: 100%;
  position: absolute;
  right: 0;
  padding: 1%;
}

.contents-column2 {
  top: 10%;
  position: relative;
}


.flex-container {
  padding: 2%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.flex-container > div {
  background-color: #0d0d0d;
  margin: 1%;
  font-size: 30px;
}

.item {
  max-width: 500px;
  border-color: rgb(185, 196, 28);
  border-radius: 10px;
  border-style:solid;
  padding: 10px;
}

.item-d {
  max-width: 500px;
  border-color: rgb(111, 117, 15);
  border-radius: 10px;
  border-style:solid;
  padding: 10px;
}

.item-d:hover {
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.42);
  transform: translateY(-5px);
}

.item:hover {
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.42);
  transform: translateY(-5px);
}

.contact {
}

.pfp {
  max-width: 400px;
  width: 100%;
  border-color: #ffffff;
  border-width: 10px;
}

.gif {
  width: 100%
}

.link {
  padding: 10px;
}

.content {
  z-index: 4;
}

.circle-container {
  display: none;
  position: relative;
  right: -40%;
  top: -15%;
  z-index: 0;
}

.circle {

  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  position:absolute;

}

.title-image {
  max-height: 20%;
  max-width: 100%;
}

.details-container {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  z-index: 4;
  background-color: #0d0d0d;
  align-items: stretch;
}

.tile-large {
  width: 45%;
  border-color: rgb(143, 151, 34);
  border-radius: 10px;
  border-style:solid;
  margin: 10px;
  flex-grow: 1;
}


.tile {
  width: 20%;
  border-color: rgb(143, 151, 34);
  border-radius: 10px;
  border-style:solid;
  margin: 10px;
  flex-grow: 1;
}

.tile:hover {
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.42);
  transform: translateY(-5px);
}

.modal {
  position: relative;
  width: 80%;
  height: 100%;
  left: 10%;
  z-index: 10;
  background-color: #393939;
  overflow-y: scroll;
}

.full-description {
  margin: 2%;
  font-size: 1.5em;
}

.background {
  height:100vh;
  width: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.703);
  z-index: 9;
}

.X {
  height: 50px;
  width: 50px;
  background-color: #fa2500;
  border-radius: 5px;
  position: absolute;
  margin: 1%;
  right: 0px;
}

.X:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  content: "\\274c"; /* use the hex value here... */
  font-size: 25px; 
  color: #FFF;
  line-height: 50px;
  text-align: center;
  
}

.X:hover {
  box-shadow: 0px 8px 16px rgba(67, 67, 67, 0.42);
  transform: translateY(-5px);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,qDAAuC;AACzC;;AAEA;EACE,qDAAwC;AAC1C;;AAEA;EACE,qDAAwC;AAC1C;;;AAGA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;EACE;aACW;AACb;;;AAGA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;;AAErB;;CAEC,UAAU;AACX;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;CACf;AACD;EACE,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;AACA;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;;AAEnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;;AAGA;EACE,UAAU;EACV,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB,EAAE,8BAA8B;EAChD,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B","sourcesContent":["html, body {\n  overflow: hidden;\n  /* just change the cursor.ico path to your location */\n}\n\n.cursor0 {\n  cursor: url(\"/public/cursor.ico\"), auto;\n}\n\n.cursor1 {\n  cursor: url(\"/public/cursor2.ico\"), auto;\n}\n\n.cursor2 {\n  cursor: url(\"/public/cursor3.ico\"), auto;\n}\n\n\n.App {\n  text-align: center;\n  background-color: hsl(0, 0%, 22%);\n  color: rgb(224, 255, 47);\n  overflow: hidden;\n}\n\n.title {\n  font-style: italic;\n  padding: 2%;\n  text-align: left;\n  align-items: left;\n  color: rgb(224, 255, 47);\n}\n\n.description {\n  font-size: .5em;\n}\n\nh2 {\n  font-family: 'Baskerville';\n  font-style:italic;\n  font-weight:normal;\n}\n\n\n\ncode {\n  font-family: code,\n    monospace;\n}\n\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  padding-top: 10%;\n  background-color: #8ea604;\n  min-height: 10vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: rgb(0, 0, 0);\n  padding: 2%;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.body {\n  height: 100%;\n  overflow-y: hidden;\n}\n\n.column1 {\n  float: left;\n  width: 68%;\n  height: 100%;\n  overflow-y: scroll;\n  scrollbar-color: rgb(255, 255, 255) #8ea604;\n  scrollbar-width:thin;\n  height: calc(100vh);\n\n}\n\n /* width */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #8ea604;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: rgb(255, 255, 255);\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n} \n\na { \n  color: inherit;\n  font-size: 80%;\n } \n.column2 {\n  border-left: 2px solid #736161;\n  float: right;\n  width: 30%;\n  background-color: #0d0d0d;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  padding: 1%;\n}\n\n.contents-column2 {\n  top: 10%;\n  position: relative;\n}\n\n\n.flex-container {\n  padding: 2%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-container > div {\n  background-color: #0d0d0d;\n  margin: 1%;\n  font-size: 30px;\n}\n\n.item {\n  max-width: 500px;\n  border-color: rgb(185, 196, 28);\n  border-radius: 10px;\n  border-style:solid;\n  padding: 10px;\n}\n\n.item-d {\n  max-width: 500px;\n  border-color: rgb(111, 117, 15);\n  border-radius: 10px;\n  border-style:solid;\n  padding: 10px;\n}\n\n.item-d:hover {\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.42);\n  transform: translateY(-5px);\n}\n\n.item:hover {\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.42);\n  transform: translateY(-5px);\n}\n\n.contact {\n}\n\n.pfp {\n  max-width: 400px;\n  width: 100%;\n  border-color: #ffffff;\n  border-width: 10px;\n}\n\n.gif {\n  width: 100%\n}\n\n.link {\n  padding: 10px;\n}\n\n.content {\n  z-index: 4;\n}\n\n.circle-container {\n  display: none;\n  position: relative;\n  right: -40%;\n  top: -15%;\n  z-index: 0;\n}\n\n.circle {\n\n  background-color: #bbb;\n  border-radius: 50%;\n  display: inline-block;\n  position:absolute;\n\n}\n\n.title-image {\n  max-height: 20%;\n  max-width: 100%;\n}\n\n.details-container {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  z-index: 4;\n  background-color: #0d0d0d;\n  align-items: stretch;\n}\n\n.tile-large {\n  width: 45%;\n  border-color: rgb(143, 151, 34);\n  border-radius: 10px;\n  border-style:solid;\n  margin: 10px;\n  flex-grow: 1;\n}\n\n\n.tile {\n  width: 20%;\n  border-color: rgb(143, 151, 34);\n  border-radius: 10px;\n  border-style:solid;\n  margin: 10px;\n  flex-grow: 1;\n}\n\n.tile:hover {\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.42);\n  transform: translateY(-5px);\n}\n\n.modal {\n  position: relative;\n  width: 80%;\n  height: 100%;\n  left: 10%;\n  z-index: 10;\n  background-color: #393939;\n  overflow-y: scroll;\n}\n\n.full-description {\n  margin: 2%;\n  font-size: 1.5em;\n}\n\n.background {\n  height:100vh;\n  width: 100%;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.703);\n  z-index: 9;\n}\n\n.X {\n  height: 50px;\n  width: 50px;\n  background-color: #fa2500;\n  border-radius: 5px;\n  position: absolute;\n  margin: 1%;\n  right: 0px;\n}\n\n.X:after {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  content: \"\\274c\"; /* use the hex value here... */\n  font-size: 25px; \n  color: #FFF;\n  line-height: 50px;\n  text-align: center;\n  \n}\n\n.X:hover {\n  box-shadow: 0px 8px 16px rgba(67, 67, 67, 0.42);\n  transform: translateY(-5px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
